import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var App: any;
declare var $: any;
@pbi.Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: [
        'dashboard.component.css'
    ]
})
export class DashBoardComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    TruyCapWeb: Number = 0;
    TruyCapGioHang: Number = 0;
    ThongKeSource: Object = [];
    TruyCapGocKinhNghiem: Number = 0;
    TruyCapLienHeTuyenDung: Number = 0;
    TitleDetail: string  = "Chi tiết truy cập của website";
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        this_sav.pb_func.loadScript([ 
            'assets/global/plugins/morris/morris.min.js',
            'assets/global/plugins/morris/raphael-min.js',
            'assets/global/plugins/counterup/jquery.waypoints.min.js',
            'assets/global/plugins/counterup/jquery.counterup.min.js',
            'assets/pages/scripts/dashboard.js',
            'assets/more/script/fixHeightContent.js'
        ], 'dashboard', function () {
            this_sav.adminService.closeLoading(function(){ 
                this_sav.LoadData(null, 'now-now', this_sav);
            });
        });

        $('.dateRangeDASHBOARD').off('change');
        $('.dateRangeDASHBOARD').change(function(){
            var val = $(this).val();
            this_sav.LoadData(this, val, this_sav);
        });
    };

    LoadData($event, date, this_sav) {
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/LogPage/DashBoard', 'POST',
        {date: date}, null, function (status, mess) {
            $('.TruyCapWebSite').attr('data-value', mess.tcws);
            $('.TruyCapGioHang').attr('data-value', mess.tcgh);
            $('.TruyCapGocKinhNghiem').attr('data-value', mess.tcgkn);
            $('.TruyCapLienHeTuyenDung').attr('data-value', mess.tclhtd);
            this_sav.ThongKeSource = mess.lst_tcws;
            // for(var i in mess.lst_tcws) {
            //     var row = mess.lst_tcws[i];
            //     ThongKeSource += `
            //         <tr>
            //             <td _ngcontent-c2>${row.ip_public}</td>
            //             <td _ngcontent-c2>${row.ip_client}</td>
            //             <td _ngcontent-c2>${row.count}</td>
            //             <td _ngcontent-c2>${row.page}</td>
            //             <td _ngcontent-c2>${row.dateShow}</td>
            //         </tr>
            //     `;
            // }
            // $('.ThongKeSource').html(ThongKeSource);
            
            this_sav.adminService.closeLoading(function(){ 
                $().counterUp && $("[data-counter='counterup']").counterUp({
                    delay: 10,
                    time: 1e3
                });
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/dashboard/dashboard.component.ts